module.exports = __webpack_public_path__ + "img/app-button.90706ad7.svg";